module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-input"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n        " + _vm._s(_vm.item.title) + ":\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [(_vm.isTypeString(_vm.item)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.answer),
      expression: "item.answer"
    }],
    attrs: {
      "placeholder": _vm.item.placeholder,
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "answer", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTypeNumber(_vm.item)) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.answer),
      expression: "item.answer"
    }],
    attrs: {
      "placeholder": _vm.item.placeholder,
      "type": "number"
    },
    domProps: {
      "value": (_vm.item.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "answer", $event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "suffix"
  }, [_vm._v("\n        " + _vm._s(_vm.item.suffix) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3577096e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionTypeInput.vue
// module id = 264
// module chunks = 1